import React, { useState } from "react";
import { Controller } from "react-hook-form";
import { Link } from "react-router-dom";
import useSignin from "../../../controllers/useSignin";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { all_routes } from "../../../Router/all_routes";

const Signin = () => {
  const { values, functions } = useSignin();

  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };
  const route = all_routes;

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper bg-img">
          <div className="login-content">
            <form action="index">
              <div className="login-userset">
                <div className="login-logo logo-normal">
                  <ImageWithBasePath src="assets/img/logo.png" alt="img" />
                </div>
                <Link to={route.dashboard} className="login-logo logo-white">
                  <ImageWithBasePath src="assets/img/logo-white.png" alt />
                </Link>
                <div className="login-userheading">
                  <h3>Sign In</h3>
                  <h4>
                    Access the Good Price Wholesale panel using your email and
                    passcode.
                  </h4>
                </div>
                <div className="form-login mb-3">
                  <Controller
                    name="email"
                    control={values.control}
                    rules={{ required: "Email is required" }}
                    render={({ field }) => (
                      <>
                        <label className="form-label">
                          Email Address <span className="text-danger"> *</span>
                        </label>
                        <div className="form-addons">
                          <input
                            placeholder="Enter Email Address"
                            type="text"
                            className="form-control"
                            {...field}
                          />
                          <ImageWithBasePath
                            src="assets/img/icons/mail.svg"
                            alt="img"
                          />
                        </div>
                      </>
                    )}
                  />
                </div>
                <div className="form-login mb-3">
                  <Controller
                    name="password"
                    control={values.control}
                    rules={{ required: "Password is required" }}
                    render={({ field }) => (
                      <>
                        <label className="form-label">
                          Password<span className="text-danger"> *</span>
                        </label>
                        <div className="pass-group">
                          <input
                            placeholder="Enter Password"
                            type={isPasswordVisible ? "text" : "password"}
                            className="pass-input form-control"
                            {...field}
                          />
                          <span
                            className={`fas toggle-password ${
                              isPasswordVisible ? "fa-eye" : "fa-eye-slash"
                            }`}
                            onClick={togglePasswordVisibility}
                          ></span>
                        </div>
                      </>
                    )}
                  />
                </div>
                <div className="form-login authentication-check">
                  <div className="row">
                    <div className="col-12 d-flex align-items-center justify-content-between">
                      <div className="custom-control custom-checkbox">
                        {/* <label className="checkboxs ps-4 mb-0 pb-0 line-height-1">
                          <input type="checkbox" className="form-control" />
                          <span className="checkmarks" />
                          Remember me
                        </label> */}
                      </div>
                      <div className="text-end">
                        <Link className="forgot-link" to={route.forgotPassword}>
                          Forgot Password?
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-login">
                  <button
                    onClick={functions.onSubmit}
                    className="btn btn-login d-flex align-items-center justify-content-center"
                    disabled={values.loading}
                  >
                    {values.loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Signing In...
                      </>
                    ) : (
                      "Sign In"
                    )}
                  </button>
                  {/* <Link onClick={functions.onSubmit} className="btn btn-login">
                    Sign In
                  </Link> */}
                </div>
                {/* <div className="signinform">
                  <h4>
                    New on our platform?
                    <Link to={route.register} className="hover-a">
                      {" "}
                      Create an account
                    </Link>
                  </h4>
                </div>
                <div className="form-setlogin or-text">
                  <h4>OR</h4>
                </div>
                <div className="form-sociallink">
                  <ul className="d-flex">
                    <li>
                      <Link to="#" className="facebook-logo">
                        <ImageWithBasePath
                          src="assets/img/icons/facebook-logo.svg"
                          alt="Facebook"
                        />
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <ImageWithBasePath
                          src="assets/img/icons/google.png"
                          alt="Google"
                        />
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="apple-logo">
                        <ImageWithBasePath
                          src="assets/img/icons/apple-logo.svg"
                          alt="Apple"
                        />
                      </Link>
                    </li>
                  </ul>
                </div> */}
                <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
                  <p>
                    Copyright © {new Date().getFullYear()} Samsal Services. All
                    rights reserved
                  </p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signin;
